var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDottedLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 2,
    viewBox: "0 0 31 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 1148",
    d: "M1 1H30",
    stroke: "#00182F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedLine);
export default __webpack_public_path__ + "static/media/dotted-line.c08a9cfdbd20893027230b3aa0789aa7.svg";
export { ForwardRef as ReactComponent };